import { CommonModule, DatePipe } from '@angular/common';
import { Component, computed, effect, inject, signal } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { AuthStore } from '../../../../core/auth/store/auth.store';

@Component({
  selector: 'app-toolbar',
  imports: [
    CommonModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
  ],
  templateUrl: './toolbar.component.html',
  styleUrl: './toolbar.component.scss',
})
export class ToolbarComponent {
  store = inject(AuthStore);
  timeDate = signal(new Date());
  formattedTime = computed(() => {
    const datePipe = new DatePipe('en-US');
    return datePipe.transform(this.timeDate(), 'HH:mm');
  });

  darkMode = signal(false);
  setDarkMode = effect(() => {
    const root = document.documentElement;
    root.classList.toggle('dark', this.darkMode());
    root.style.colorScheme = this.darkMode() ? 'dark' : 'light';
    const html = document.querySelector('html');
    html!.classList.toggle('dark', this.darkMode());
  });

  isAuthenticated = this.store.isAuthenticated;

  logout() {
    this.store.logout();
  }
}
